import React, { useState } from "react";
import { Button } from "@material-ui/core";
import ImportCostModal from "./import.cost.modal";
import styled from "styled-components";
import OutlinedButton from "../../../../app/components/buttons/outlined";

export default function ImportCost({ studyId, scheduleId, siteGroupId }) {
  const [open, setOpen] = useState(false);
  return (
    <Container>
      <OutlinedButton onClick={() => setOpen(true)}>
        IMPORT COUNTRY COSTS
      </OutlinedButton>
      <ImportCostModal
        open={open}
        handleClose={() => setOpen(false)}
        studyId={studyId}
        scheduleId={scheduleId}
        siteGroupId={siteGroupId}
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`;
